



































































































































































































































import Vue from "vue";
import SingleBlock from "@/components/travel_planning/SingleBlock.vue";
import LabelHorizontal from "@/components/travel_planning/LabelHorizontal.vue";
import LabelVertical from "@/components/travel_planning/LabelVertical.vue";
export default Vue.extend({
  data() {
    return {
      chartSettings: {
        stack: {
          xxx: ["cost", "profit"],
        },
      },
      stackedChartSettings: {
        stack: {
          xxx: [
            "Car - low occupancy",
            "Car - high occupancy",
            "carpool",
            "school bus, public transport, walk or cycle",
          ],
        },
        colors: ["red"],
      },
      stackedChartSettingsStaff: {
        stack: {
          xxx: [
            "low occupancy",
            "carpool",
            "school bus, public transport, walk or cycle",
          ],
        },
        colors: ["red"],
      },
      radiusChartSettings: {
        label: {
          normal: {
            show: false,
            position: "center",
          },
        },
        // roseType: "radius",
      },
      // pieColors: () => {
      //   return ["#FF8700", "#FBDE05", "#9FD59F"];
      // }
    };
  },
  props: {
    stats: {
      default: () => [],
    },
    options: {
      default() {
        return {
          type: "all",
        };
      },
    },
  },
  components: {
    SingleBlock,
    LabelHorizontal,
    LabelVertical,
  },
  computed: {
    chartData: function () {
      if (this.stats && this.stats.carsVsSustainable) {
        if (this.options.type == "staff") {
          return {
            columns: [
              "distance_group",
              "low occupancy",
              "carpool",
              "school bus, public transport, walk or cycle",
            ],
            rows: this.stats.carsVsSustainable.map((itm) => {
              return {
                distance_group: itm.distance_group,
                "low occupancy":
                  itm["Car - low occupancy"] + itm["Car - high occupancy"],
                carpool: itm.carpool,
                "school bus, public transport, walk or cycle":
                  itm["school bus, public transport, walk or cycle"],
              };
            }),
          };
        } else {
          return {
            columns: [
              "distance_group",
              "Car - low occupancy",
              "Car - high occupancy",
              "carpool",
              "school bus, public transport, walk or cycle",
            ],
            rows: this.stats.carsVsSustainable,
          };
        }
      } else {
        return null;
      }
    },
    pieColors: () => {
      // if (this.stats) {
      return ["#FF8700", "#ffb100", "#FBDE05", "#9FD59F"];
      // } else return null;
    },
    pieData: function () {
      if (this.stats && this.stats.carsVsSustainableTotal) {
        return {
          columns: ["type", "count"],
          rows: [
            {
              type: "Car - low occupancy",
              count:
                this.stats.carsVsSustainableTotal[0]["Car - low occupancy"],
            },
            {
              type: "Car - high occupancy",
              count:
                this.stats.carsVsSustainableTotal[0]["Car - high occupancy"],
            },
            {
              type: "carpool",
              count: this.stats.carsVsSustainableTotal[0]["carpool"],
            },
            {
              type: "school bus, public transport, walk or cycle",
              count:
                this.stats.carsVsSustainableTotal[0][
                  "school bus, public transport, walk or cycle"
                ],
            },
          ],
        };
      } else {
        return null;
      }
    },
    totalCo2: function () {
      if (this.stats) {
        let total = 0;
        this.stats.co2ByTransport.map((itm) => {
          if (itm.primary_transport_type === "CARPOOL") {
            total += parseFloat(itm.total_co2) / 3;
          } else {
            total += parseFloat(itm.total_co2);
          }
        });
        return total;
      } else {
        return null;
      }
    },
    lowOccupancyCarUsage: function () {
      if (this.stats && this.stats.carsVsSustainableTotal) {
        const total =
          this.stats.carsVsSustainableTotal[0]["Car - low occupancy"] +
          this.stats.carsVsSustainableTotal[0]["Car - high occupancy"] +
          this.stats.carsVsSustainableTotal[0]["carpool"] +
          this.stats.carsVsSustainableTotal[0][
            "school bus, public transport, walk or cycle"
          ];

        return (
          (this.stats.carsVsSustainableTotal[0]["Car - low occupancy"] /
            total) *
          100
        );
      } else {
        return null;
      }
    },
    usersSharing: function () {
      if (this.stats) {
        const total =
          this.stats.user_open_to_sharing + this.stats.user_not_open_to_sharing;
        return ((this.stats.user_open_to_sharing / total) * 100).toFixed(1);
      } else {
        return null;
      }
    },
  },
});
